import { render, staticRenderFns } from "./SgTab.vue?vue&type=template&id=6d753d11&"
import script from "./SgTab.vue?vue&type=script&lang=js&"
export * from "./SgTab.vue?vue&type=script&lang=js&"
import style0 from "./SgTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports